import { Modal } from "antd";
import React, { useState } from "react";
import VersionConformTable from "./VersionConformTable";

function CreateVersion({ versionList }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    console.log("Modal confirmed!");
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    console.log("Modal cancelled!");
    setIsModalOpen(false);
  };

  return (
    <div>
      <button
        onClick={showModal}
        className=" bg-[#0057b8] h-[31px] mx-2 px-3 rounded text-[13px] text-white"
      >
        Create Server Version
      </button>
      <Modal
        destroyOnClose={true}
        onCancel={handleCancel}
        title="Create Server Version"
        open={isModalOpen}
        footer={null}
      >
        {/* {JSON.stringify(versionList)} */}

        <VersionConformTable
          clientData={versionList?.clients}
          handleCancel={handleCancel}
        />
        {/* Add your form or input fields here */}
      </Modal>
    </div>
  );
}

export default CreateVersion;
